<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main-fluid";
import ExpedienteLista from "@components/ExpedienteLista";
import TimelineGestao from "@components/TimelineGestao";

export default {
  page: {
    title: "Página inicial",
    meta: [{ name: "description", content: appConfig.description }]
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  components: {
    Layout,
    ExpedienteLista,
    TimelineGestao
  },
  methods: {
    callNew() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Expediente/Novo`,
          props: {
            editable: true
          }
        }
      );
    }
  },
  data() {
    return {
      title: "Página inicial",
      items: [
        {
          text: "Página inicial",
          href: "/",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <!-- Linha do Tempo Executiva para Gestão (Apenas Administradores) -->
    <TimelineGestao v-if="user && user.perfil === 'Administrador'" />

    <!-- Listagem e Filtro de Expedientes -->
    <div class="card-box">
      <ExpedienteLista />
    </div>
  </Layout>
</template>
